// extracted by mini-css-extract-plugin
module.exports =  {"root":"smXpz8pTXRSzD4QPVQg3"};